// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__pyTOc","addWidgetButton":"Header_addWidgetButton__3iwvq","dashboardTabs":"Header_dashboardTabs__fPoGm","active":"Header_active__1S-hu"};